import { StationListDOI } from 'src/pages/stationList/api/stationListApi';

export default class StationTreeUtils {
    static getAreaStationTree(data:StationListDOI.RowDataI[], provinceExpand = false, cityExpand = false, distryExpand = false) {
        if(data.length === 0) {return []}
        let newData:any[] = []
        newData = this.groupBy(data, 'province_name', 'province_id', provinceExpand);
        newData.forEach(element => {
            element.children = this.groupBy(element.children, 'city_name', 'city_id', cityExpand);
        });
        newData.forEach(element => {
            element.children.forEach(i => {
                i.children = this.groupBy(i.children, 'district_name', 'district_id', distryExpand);
            });
        });
        
        return [
            {
                title: '中国',
                children: newData,
                expand: true
            }
        ]
    }

    static getBasinStationTree(data:StationListDOI.RowDataI[],basinExpand: boolean = false) {
        if(data.length === 0) {return []}
        let newData:any[] = []
        newData = this.groupBy(data, 'basin', 'basin', basinExpand);
        return [
            {
                title: '中国',
                children: newData,
                expand: true
            }
        ]
    }
    static groupBy(data: StationListDOI.RowDataI[], nameField: string, idField: string, expand = false) {
        if (!data[0][nameField]) {
            return data;
        }
        let map: { [str: string]: StationListDOI.RowDataI[] } = {};
        data.forEach(element => {
            map[element[nameField]] = map[element[nameField]] || [];
            map[element[nameField]].push(element);
        });
        return Object.values(map).map(i => ({
            title: i[0][nameField],
            id: i[0][idField],
            children: i,
            expand,
        }));
    }
}
